/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyControlPanelBrowserTypename = "PharmacyControlPanelBrowser" as const;

/**
 *
 * @export
 * @interface PharmacyControlPanelBrowser
 */
export interface PharmacyControlPanelBrowser {
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelBrowser
   */
  executeFile?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelBrowser
   */
  name?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyControlPanelBrowser
   */
  readonly __typename?: string;
}

export function PharmacyControlPanelBrowserFromJSON(json: any): PharmacyControlPanelBrowser {
  return PharmacyControlPanelBrowserFromJSONTyped(json, false);
}

export function PharmacyControlPanelBrowserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyControlPanelBrowser {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyControlPanelBrowserTypename,

    executeFile: !exists(json, "execute_file") ? undefined : json["execute_file"],
    name: !exists(json, "name") ? undefined : json["name"],
  };
}

export function PharmacyControlPanelBrowserToJSON(object?: PharmacyControlPanelBrowser | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    execute_file: value.executeFile,
    name: value.name,
  };
}
